import { Injectable } from '@angular/core';
import { Configuration, Encrypted } from '../Constants/configuration';
import { CRM, notificacion, modeloCRM } from '../modelos/notificacion.model';
import { RequestServices } from './request.service';
import { Cias } from '../modelos/cias.model';
import { ErrorConfig } from './emision.service.config';
import { StorageService } from './storage.service';
import { CocheSeguro } from '../modelos/cocheSeguro.model';
import { strict } from 'assert';
import { Notification } from 'rxjs';

export class NotificacionService {
    public cias: Cias = new Cias();
    public notificacion: CRM = new CRM();
    private storageService: StorageService = new StorageService();

    constructor(private requestServices?: RequestServices) {
    }

    notificacionCRM(notificacion: notificacion) {
        let cocheSeguro: CocheSeguro = new CocheSeguro();
        if (this.storageService.ifExist("cocheSeguro")) {
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }
        let msgError = "";
        if (notificacion?.url) {
            msgError += '\nServicio: ' + this.getURLOrigen(notificacion.url);
        }
        msgError += '\nOrigen: Coche-Seguro';
        if (notificacion?.cotizacionID && notificacion.cotizacionID != "0") {
            msgError += '\nCotización: ' + notificacion.cotizacionID;
        } else if (cocheSeguro?.cot_id) {
            msgError += '\nCotización: ' + cocheSeguro.cot_id;
        }
        if (notificacion?.emisionID) {
            msgError += '\nEmisión: ' + notificacion.emisionID;
        }
        if (notificacion?.noPoliza) {
            msgError += '\nPóliza: ' + notificacion.noPoliza;
        }
        if (notificacion?.aseguradoraID) {
            msgError += '\nAseguradora: ' + this.cias.alias(notificacion?.aseguradoraID);
        }
        if (notificacion?.msgError) {
            msgError += '\nError: ' + notificacion.msgError;
        }
        if (cocheSeguro?.dataVehiculo?.datosAuto?.descripcion) {
            msgError += '\nVehiculo: ' + cocheSeguro.dataVehiculo.datosAuto.descripcion;
        }
        if (cocheSeguro?.vehiculo?.serie) {
            msgError += '\nnoSerie: ' + cocheSeguro.vehiculo.serie;
        }
        if (cocheSeguro?.prospecto?.nombre) {
            msgError += '\nContratante: ' + cocheSeguro?.prospecto.nombre;
        }
        if (cocheSeguro?.prospecto?.correo) {
            msgError += '\nCorreo: ' + cocheSeguro?.prospecto.correo;
        }
        if (cocheSeguro?.telefono) {
            msgError += '\nCelular: ' + cocheSeguro?.telefono;
        }
        msgError += this.navigatorErrorSelector();

        let clienteID = 0;

        this.validaAsunto(notificacion, msgError, clienteID);
    }

    private sendNotificacion(modelo: modeloCRM, aseguradoraId?: number, crmStatus_id?: number) {
        let configuration: Configuration = new Configuration();
        let cocheSeguro: CocheSeguro = new CocheSeguro();
        if (this.storageService.ifExist("cocheSeguro")) cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        let clienteID: any = 0;
        if (cocheSeguro.clEnt && cocheSeguro.clEnt !== "") {
            clienteID = cocheSeguro.clEnt;
        } else {
            clienteID = modelo.clienteId;
        }
        if (crmStatus_id != null && crmStatus_id > 0) {
            if (modelo.asunto != "") {
                this.GeneraCRM({ v1: configuration.worksiteId, v2: modelo.asunto, v3: modelo.mensaje, v4: { c1: clienteID }, entidadTipo: 29, entidad: this.storageService.ifExist("logConsumoId") ? this.storageService.getItem("logConsumoId") : new Encrypted().ZERO, crmStatus: crmStatus_id });
            } else {
                this.GeneraCRM({ v1: configuration.worksiteId, v2: "Coche Seguro (Error) - " + this.cias.alias(aseguradoraId), v3: modelo.mensaje, v4: { c1: clienteID }, entidadTipo: 29, entidad: this.storageService.ifExist("logConsumoId") ? this.storageService.getItem("logConsumoId") : new Encrypted().ZERO, crmStatus: crmStatus_id });
            }
        } else {
            if (modelo.asunto != "") {
                this.GeneraCRM({ v1: configuration.worksiteId, v2: modelo.asunto, v3: modelo.mensaje, v4: { c1: clienteID }, entidadTipo: 29, entidad: this.storageService.ifExist("logConsumoId") ? this.storageService.getItem("logConsumoId") : new Encrypted().ZERO });
            } else {
                this.GeneraCRM({ v1: configuration.worksiteId, v2: "Coche Seguro (Error) - " + this.cias.alias(aseguradoraId), v3: modelo.mensaje, v4: { c1: clienteID }, entidadTipo: 29, entidad: this.storageService.ifExist("logConsumoId") ? this.storageService.getItem("logConsumoId") : new Encrypted().ZERO });
            }
        }
    }

    private GeneraCRM(mensaje: CRM) {
        this.requestServices.postRequest({ projectName: new Configuration().URLESTRUCTURA, apiName: "Sio4CrmLogErroresAPI", dataJSON: mensaje }).subscribe(
            result => {
                if (result.error) {
                    console.error(result.error);
                } else {
                }
            }, error => {
                console.error("Ocurrió un problema durante el proceso", error);
            });
    }

    private navigatorErrorSelector(): string {
        let error = '';
        if (navigator) {
            error += '\nNav. platform: ' + navigator.platform;
            if (navigator.userAgent.indexOf('MSIE') !== -1) {
                error += '\nNav. navegador: Internet explorer\'';
            } else if (navigator.userAgent.indexOf('Edge') !== -1) {
                error += '\nNav. navegador: Microsoft Edge';
            } else if (navigator.userAgent.indexOf('Trident') !== -1) {
                error += '\nNav. navegador: Internet explorer 11';
            } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
                error += '\nNav. navegador: Firefox';
            } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
                error += '\nNav. navegador: Chrome';
            } else if (navigator.userAgent.indexOf('Safari') !== -1) {
                error += '\nNav. navegador: Safari';
            } else {
                error += '\nNav. navegador: ' + navigator.userAgent;
            }
            error += '\nVersion: ' + new Configuration().VERSION_PROYECTO;
        }
        return error;
    }

    private getURLOrigen(url: string): string {
        let donde: string = "No Configurado";
        if (url.includes("cotizacion")) {
            url = "/" + url.split("/")[1];
        }
        switch (url) {
            case "/inicio": case "/cotizacion":
                donde = "Cotización";
                break;
            case "/datos-tarjeta": case "/datos-emision-vehiculo":
                donde = "Emision";
                break;
            case "/login-pel":
                donde = "Pasarela";
                break;
            case "/impresion": case "/archivos": case "/mi-cuenta/impresion":
                donde = "Impresion";
                break;
        }
        return donde;
    }

    validaAsunto(notificacion: notificacion, msgError: string, clienteID: number) {
        let cocheSeguro: CocheSeguro = new CocheSeguro();
        if (this.storageService.ifExist("cocheSeguro")) {
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }
        let asunto: string = "";
        if (cocheSeguro?.dataVehiculo?.datosAuto?.descripcion && cocheSeguro?.dataVehiculo?.multicotiza) {
            if (notificacion.msgError.includes("Error al obtener producto adecuado")) {
                asunto = "Coche Seguro (Homologación) - " + this.cias.alias(notificacion?.aseguradoraID) + " / " + cocheSeguro?.dataVehiculo.multicotiza.f4 + " " + cocheSeguro?.dataVehiculo?.datosAuto?.descripcion;
            } else if (notificacion.msgError.includes("Error al obtener producto adecuado")) {
                asunto = "Coche Seguro (Homologación) - " + this.cias.alias(notificacion?.aseguradoraID) + " / " + cocheSeguro?.dataVehiculo.multicotiza.f4 + " " + cocheSeguro?.dataVehiculo?.datosAuto?.descripcion;
            } else if (notificacion.msgError.includes("Vehiculo [") && notificacion.msgError.includes("] no existente")) {
                asunto = "Coche Seguro (Homologación) - " + this.cias.alias(notificacion?.aseguradoraID) + " / " + cocheSeguro?.dataVehiculo.multicotiza.f4 + " " + cocheSeguro?.dataVehiculo?.datosAuto?.descripcion;
            } else if (notificacion.msgError.includes("The '") && notificacion.msgError.includes("' element has an invalid value according to its data type.")) {
                asunto = "Coche Seguro (Homologación) - " + this.cias.alias(notificacion?.aseguradoraID) + " / " + cocheSeguro?.dataVehiculo.multicotiza.f4 + " " + cocheSeguro?.dataVehiculo?.datosAuto?.descripcion;
            } else if (notificacion.msgError.includes("El vehículo no esta homologado")) {
                asunto = "Coche Seguro (Homologación) - " + this.cias.alias(notificacion?.aseguradoraID) + " / " + cocheSeguro?.dataVehiculo.multicotiza.f4 + " " + cocheSeguro?.dataVehiculo?.datosAuto?.descripcion;
            } else if (notificacion.msgError.includes("El Id del vehículo no se encuentra asignado en esta Tarifa")) {
                asunto = "Coche Seguro (Homologación) - " + this.cias.alias(notificacion?.aseguradoraID) + " / " + cocheSeguro?.dataVehiculo.multicotiza.f4 + " " + cocheSeguro?.dataVehiculo?.datosAuto?.descripcion;
            } else if (notificacion.msgError.includes("No se encontró ningun vehículo con la clave vehicular")) {
                asunto = "Coche Seguro (Homologación) - " + this.cias.alias(notificacion?.aseguradoraID) + " / " + cocheSeguro?.dataVehiculo.multicotiza.f4 + " " + cocheSeguro?.dataVehiculo?.datosAuto?.descripcion;
            } else if (notificacion.msgError.includes("Favor de verificar el número de serie, ya que el número proporcionado presenta anomalías")) {
                asunto = "Coche Seguro (Serie) - " + this.cias.alias(notificacion?.aseguradoraID);
            } else if (notificacion.msgError.includes("Serie Amparada en Poliza Vigente")) {
                asunto = "Coche Seguro (Serie Asegurada) - " + this.cias.alias(notificacion?.aseguradoraID);
            } else if (notificacion.msgError.includes("El número de serie ya existe en la póliza")) {
                asunto = "Coche Seguro (Serie Asegurada) - " + this.cias.alias(notificacion?.aseguradoraID);
            } else if (notificacion.msgError.includes("Numero de serie") && notificacion.msgError.includes("Registrado en una poliza vigente")) {
                asunto = "Coche Seguro (Serie Asegurada) - " + this.cias.alias(notificacion?.aseguradoraID);
            } else if (notificacion.msgError.includes("Cancelación Exitosa")) {
                asunto = "Coche Seguro (Cancelacion) - " + this.cias.alias(notificacion?.aseguradoraID);
            } else {
                asunto = "Coche Seguro (Error) - " + this.cias.alias(notificacion?.aseguradoraID);
            }
        } else {
            if (notificacion.msgError.includes("Error al obtener producto adecuado")) {
                asunto = "Coche Seguro (Homologación) - " + this.cias.alias(notificacion?.aseguradoraID);
            } else if (notificacion.msgError.includes("Error al obtener producto adecuado")) {
                asunto = "Coche Seguro (Homologación) - " + this.cias.alias(notificacion?.aseguradoraID);
            } else if (notificacion.msgError.includes("Vehiculo [") && notificacion.msgError.includes("] no existente")) {
                asunto = "Coche Seguro (Homologación) - " + this.cias.alias(notificacion?.aseguradoraID);
            } else if (notificacion.msgError.includes("The '") && notificacion.msgError.includes("' element has an invalid value according to its data type.")) {
                asunto = "Coche Seguro (Homologación) - " + this.cias.alias(notificacion?.aseguradoraID);
            } else if (notificacion.msgError.includes("El vehículo no esta homologado")) {
                asunto = "Coche Seguro (Homologación) - " + this.cias.alias(notificacion?.aseguradoraID);
            } else if (notificacion.msgError.includes("El Id del vehículo no se encuentra asignado en esta Tarifa")) {
                asunto = "Coche Seguro (Homologación) - " + this.cias.alias(notificacion?.aseguradoraID);
            } else if (notificacion.msgError.includes("No se encontró ningun vehículo con la clave vehicular")) {
                asunto = "Coche Seguro (Homologación) - " + this.cias.alias(notificacion?.aseguradoraID);
            } else if (notificacion.msgError.includes("Favor de verificar el número de serie, ya que el número proporcionado presenta anomalías")) {
                asunto = "Coche Seguro (Serie) - " + this.cias.alias(notificacion?.aseguradoraID);
            } else if (notificacion.msgError.includes("Serie Amparada en Poliza Vigente")) {
                asunto = "Coche Seguro (Serie Asegurada) - " + this.cias.alias(notificacion?.aseguradoraID);
            } else if (notificacion.msgError.includes("El número de serie ya existe en la póliza")) {
                asunto = "Coche Seguro (Serie Asegurada) - " + this.cias.alias(notificacion?.aseguradoraID);
            } else if (notificacion.msgError.includes("Numero de serie") && notificacion.msgError.includes("Registrado en una poliza vigente")) {
                asunto = "Coche Seguro (Serie Asegurada) - " + this.cias.alias(notificacion?.aseguradoraID);
            } else if (notificacion.msgError.includes("Cancelación Exitosa")) {
                asunto = "Coche Seguro (Cancelacion) - " + this.cias.alias(notificacion?.aseguradoraID);
            } else {
                asunto = "Coche Seguro (Error) - " + this.cias.alias(notificacion?.aseguradoraID);
            }
        }
        /* Se solicito que todos los CRM se añadan con status 35 */
        /* if (asunto.includes("Coche Seguro (Homologación)")) { */
            /* Se solicito que los CRM por homologacion se pasaran a completo neutro por default. */
            this.sendNotificacion({ mensaje: msgError, clienteId: clienteID, asunto: asunto }, notificacion?.aseguradoraID, 35);
        /* } else {
            this.sendNotificacion({ mensaje: msgError, clienteId: clienteID, asunto: asunto }, notificacion?.aseguradoraID);
        } */
    }
}